import { mapMethods } from './api'

const ENDPOINT = 'meetings' // TEMP: 

export const key = 'id' 

export default {
    ENDPOINT,
    key,
    ...mapMethods(ENDPOINT, [
        'view',
        'search',
        'delete',
        'update',
        'create'
    ]),
}
